import React, { useEffect } from 'react';
import { getAuthCredentialsFromUrl } from '../../../utils/jwt-helpers';

export function useUrlCredentials(search) {
  useEffect(() => {
    getAuthCredentialsFromUrl(search);
  }, []);
}
